import React from "react";
import { Link } from "react-router-dom";

export const DOMAIN_PAGE_STYLES = `
  .fin-page {
    font-family: Roboto, sans-serif;
    color: #1e2a3b;
    background: #27baa7;
    min-height: 60vh;
  }

  .fin-hero {
    background: #1d3f7d;
    padding: 52px 35px 48px;
  }
  .fin-hero-inner { max-width: 1100px; margin: 0 auto; }
  .fin-hero h1 {
    font-family: Exo, sans-serif;
    font-size: 40px;
    font-weight: 700;
    color: #fff;
    margin: 0 0 14px;
    line-height: 1.15;
  }
  .fin-hero p {
    font-size: 17px;
    line-height: 1.75;
    color: rgba(255, 255, 255, 0.92);
    margin: 0;
    max-width: 820px;
  }

  .fin-wrap {
    max-width: 1100px;
    margin: 0 auto;
    padding: 48px 35px 72px;
  }

  .fin-section { margin-bottom: 44px; scroll-margin-top: 120px; }
  .fin-section:last-child { margin-bottom: 0; }
  .fin-section h2 {
    font-family: Exo, sans-serif;
    font-size: 24px;
    color: #0e2440;
    margin: 0 0 22px;
    font-weight: 700;
    padding-bottom: 10px;
    border-bottom: 3px solid #1d3f7d;
  }

  .fin-list { display: flex; flex-direction: column; gap: 28px; }

  .fin-card {
    background: #fff;
    border-radius: 12px;
    overflow: hidden;
    scroll-margin-top: 88px;
    box-shadow: 0 4px 20px rgba(29, 63, 125, 0.08);
  }
  .fin-card-body { padding: 28px 30px 24px; }
  .fin-card h3 {
    font-family: Exo, sans-serif;
    font-size: 21px;
    color: #1d3f7d;
    margin: 0 0 20px;
    line-height: 1.35;
  }

  .fin-cs {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
  }
  .fin-cs-block {
    background: #fff;
    border-radius: 10px;
    padding: 20px 22px;
    border: 1px solid #dbe7f7;
    border-left: 4px solid;
  }
  .fin-cs-block.challenge { border-left-color: #1d3f7d; }
  .fin-cs-block.solution { border-left-color: #27baa7; }
  .fin-cs-block h4 {
    font-family: Exo, sans-serif;
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    margin: 0 0 10px;
  }
  .fin-cs-block.challenge h4 { color: #1d3f7d; }
  .fin-cs-block.solution h4 { color: #178f80; }
  .fin-cs-block p {
    font-size: 15px;
    line-height: 1.74;
    color: #2a3a4c;
    margin: 0;
  }

  .fin-card-pic {
    border-top: 1px solid #e2eaf4;
    background: #f8fbff;
    padding: 18px;
  }
  .fin-card-pic img,
  .fin-card-pic .flow-diagram-img {
    width: 100%;
    max-width: 100%;
    display: block;
    border-radius: 8px;
    height: auto;
    image-rendering: auto;
  }
  .flow-diagram-fallback {
    padding: 28px 20px;
    text-align: center;
    color: #6b7c90;
    font-size: 14px;
    border-radius: 8px;
    border: 1px dashed #cfe0f5;
    background: #fff;
  }

  @media (max-width: 768px) {
    .fin-hero { padding: 36px 20px 32px; }
    .fin-hero h1 { font-size: 28px; }
    .fin-wrap { padding: 36px 20px 56px; }
    .fin-cs { grid-template-columns: 1fr; }
    .fin-card-body { padding: 22px 20px 20px; }
  }

  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }
`;

export default function DomainUseCaseCard({ useCase, flow, canonicalUrl }) {
  const url = canonicalUrl || useCase.canonicalUrl;
  const detailPath = useCase.canonicalPath;

  return (
    <article
      className="fin-card"
      id={useCase.id}
      itemScope
      itemType="https://schema.org/TechArticle"
    >
      <div className="fin-card-body">
        <h3 itemProp="headline">
          {detailPath ? (
            <Link to={detailPath} style={{ color: "inherit", textDecoration: "none" }}>
              {useCase.title}
            </Link>
          ) : (
            useCase.title
          )}
        </h3>
        <div className="fin-cs">
          <section className="fin-cs-block challenge" aria-label="The Challenge">
            <h4>The Challenge</h4>
            <p itemProp="description">{useCase.challenge}</p>
          </section>
          <section className="fin-cs-block solution" aria-label="Our Solution">
            <h4>Our Solution</h4>
            <p itemProp="text">{useCase.solution}</p>
          </section>
        </div>
        {useCase.seoSummary ? (
          <p className="sr-only" itemProp="abstract">
            {useCase.seoSummary}
          </p>
        ) : null}
      </div>
      <figure className="fin-card-pic" itemProp="image">
        {flow}
      </figure>
      {url ? <link itemProp="url" href={url} /> : null}
      {useCase.automationType ? <meta itemProp="genre" content={useCase.automationType} /> : null}
      <meta itemProp="keywords" content={useCase.seoKeywords} />
      <meta itemProp="articleSection" content={useCase.subIndustry} />
    </article>
  );
}

